import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex cursor-pointer items-center gap-2 tracking-[0.06em] uppercase'
  },
  variants: {
    size: {
      xs: {
        base: 'heading-xs-bold'
      },
      s: {
        base: 'heading-s-bold'
      }
    }
  },
  defaultVariants: {
    size: 's'
  }
});
